import React, {useEffect} from 'react';
import Box from "@mui/material/Box";
import {useSelector} from "react-redux";
import {findFlagUrlByIso2Code} from 'country-flags-svg';

const EventSelector = () => {
    const event = useSelector(state => state.session.event)

    return (
        <>
        {event &&
            <Box sx={{
                mx:'1em',
                px:'1em',
                py:'10px',
                background:'#333333',
                display:'flex',
                alignItems:'center',
            }}>
                {event.country &&
                    <img src={findFlagUrlByIso2Code(event.country)} style={{height:'1.2em',marginRight:'1em'}}/>
                }
                {event.fullEditionTitle}
            </Box>
        }
        </>
    );
};

export default EventSelector;